import { useTranslation } from "@opendash/i18n";
import { Tour, TourProps } from "antd";
import React, { useState } from "react";
import { useUserGuideSelect } from "../../../hooks/useUserGuideSelect";
import { TourId } from "../../../types/TourId";
import TourButton from "../TourButton";

export default () => {
  const t = useTranslation();
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(0);
  const select = useUserGuideSelect<TourId.Stop>();

  const steps: TourProps["steps"] = [
    {
      title: t("gtfs:tour.stop.start.title"),
      description: t("gtfs:tour.stop.start.description"),
    },
    {
      title: t("gtfs:tour.stop.create.title"),
      description: t("gtfs:tour.stop.create.description"),
      target: select(TourId.Stop.create),
      onNext: () => {
        select(TourId.Stop.create)?.click();
        setTimeout(() => {
          setCurrent((prev) => prev + 1);
        }, 500);
      },
    },
    {
      title: t("gtfs:tour.stop.modal.title"),
      description: t("gtfs:tour.stop.modal.description"),
      target: select(TourId.Stop.modal),
      onPrev: () => {
        select(TourId.Stop.close)?.click();
        setCurrent((prev) => prev - 1);
      },
    },
    {
      title: t("gtfs:tour.stop.save.title"),
      description: t("gtfs:tour.stop.save.description"),
      target: select(TourId.Stop.save),
      onNext: () => {
        select(TourId.Stop.close)?.click();
        select(TourId.Stop.card)?.setAttribute("style", "display: block");
        setCurrent((prev) => prev + 1);
      },
    },
    {
      title: t("gtfs:tour.stop.overview.title"),
      description: t("gtfs:tour.stop.overview.description"),
      target: select(TourId.Stop.card),
      onPrev: () => {
        select(TourId.Stop.create)?.click();
        select(TourId.Stop.card)?.setAttribute("style", "display: none");
        setTimeout(() => {
          setCurrent((prev) => prev - 1);
        }, 500);
      },
      onNext: () => {
        setCurrent((prev) => prev + 1);
        select(TourId.Stop.card)?.setAttribute("style", "display: none");
      },
    },
    {
      title: t("gtfs:tour.stop.end.title"),
      description: t("gtfs:tour.stop.end.description"),
    },
  ];

  function onEndTour() {
    setOpen(false);
    setCurrent(0);
  }

  return (
    <>
      <TourButton
        onClick={() => setOpen(true)}
        title={t("gtfs:tour.route.button.title")}
      />
      <Tour
        steps={steps}
        open={open}
        onClose={() => onEndTour()}
        current={current}
        onChange={(cur) => setCurrent(cur)}
      />
    </>
  );
};
